var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-banner alert border-0 rounded-0 py-2 py-md-3 mb-0",style:(_vm.style),attrs:{"role":"alert"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),(_vm.options.linkText && _vm.options.linkHref)?_c('a',{staticClass:"ml-2",attrs:{"href":_vm.options.linkHref}},[_vm._v(_vm._s(_vm.options.linkText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }